import { render, staticRenderFns } from "./SplitPronun.vue?vue&type=template&id=367c0f52&scoped=true"
import script from "./SplitPronun.vue?vue&type=script&lang=js"
export * from "./SplitPronun.vue?vue&type=script&lang=js"
import style0 from "./SplitPronun.vue?vue&type=style&index=0&id=367c0f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367c0f52",
  null
  
)

export default component.exports